import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { METAS } from 'src/environments/metas';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DataService } from '../shared/services/data.service';

@Injectable({
   providedIn: 'root'
})
export class SEOResolve implements Resolve<any>{

   constructor(
      public meta: Meta, 
      public title: Title,
      public dataService:DataService
      ) {

   }

   async resolve(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) : Promise<any> {
      let idioma = 'x';
      this.dataService.$idioma.subscribe( v => idioma = v)
      this.setProperty(state.url, idioma);
      return true;
   }

   setTitle(title) {
      this.title.setTitle(title);
   }

   setMeta(name, description) {
      this.meta.addTag({ name: name, content: description });
   }

   setProperty(routeToSet, lang) {
      console.log(routeToSet)
      let metas = METAS;
      let property = null;

      metas.forEach((val, key) => {
         val['rutas'].forEach((valRu) => {
            if(valRu === routeToSet){
               property = val['detalle'][lang];
            }
         })
      })

      if(property){
         this.setTitle(property['title']);
         this.setMeta('descripcion', property['description']);
         this.setMeta('robots', property['index'])
      }
   }


}
